import { boolIsTrue, getAge } from "helpers/toolsHelper";
import { DEPENDENT_RELATIONSHIPS } from "constants/validationConstants";

const getFilteredBenefits = (includeOptionalBenefits, excludeBenefits, allowedBenefits) => {
    return allowedBenefits.filter(benefit => {
        return includeOptionalBenefits || !excludeBenefits.includes(benefit);
    })
}

const isFemale = (data) => {
    const userIsFemale = 18 <= getAge(data.birthday) && getAge(data.birthday) <= 43 && data.gender == 2;
    const dependantIsFemale = data.dependants.find((dependant) => 18 <= getAge(dependant.birthday) && getAge(dependant.birthday) <= 43 && dependant.gender == 2 && dependant.componentId === DEPENDENT_RELATIONSHIPS.SPOUSE);

    return userIsFemale || (dependantIsFemale && boolIsTrue(data.addDependant));
}

export const transformData = (data, language = 'es', apQuoteId = null) => {
    let allowedBenefits = ["geogrcov", "provdnet", "congenit", "hazardsp", "inmental", "orgtrans", "deathcov", "mxoutcov", "compther", "deductbl"];
    let allowedRider = ["healthch", "matrnity", "eyesurgr", "barsurgr"]

    const excludeOutpatientBenefits = ["mxoutcov", "compther"];

    // Valores de opciones a cambiar por 0
    const notValueOptions = ['compther_no', 'mxoutcov_unlimited', 'inmental_no', 'matrnity_no', 'eyesurgr_no', 'barsurgr_no']

    if (!data.addDependant) {
        allowedBenefits = allowedBenefits.filter(benefit => benefit !== 'deathcov')
    }

    allowedBenefits = getFilteredBenefits(data.outpationBenefitsEnabled, excludeOutpatientBenefits, allowedBenefits)

    let benefits = Object.keys(data.selectedBenefitsIds)
        .filter((benefitName) => allowedBenefits.includes(benefitName.toLowerCase()))
        .map((benefitName) => ({
            benefitCode: benefitName.toLowerCase(),
            optionCode: data.selectedBenefitsIds[benefitName],
        }))

    if (data.addDependant) {
        const deathcovIndex = benefits.findIndex(b => b.benefitCode === 'deathcov');

        if (deathcovIndex === -1) {
            benefits.push({
                benefitCode: 'deathcov',
                optionCode: 'deathcov_no'
            });
        }
    }

    if (!data.outpationBenefitsEnabled) {
        const mxoutcovIndex = benefits.findIndex(b => b.benefitCode === 'mxoutcov');
        if (mxoutcovIndex === -1) {
            benefits.push({
                benefitCode: 'mxoutcov',
                optionCode: 'mxoutcov_no'
            })
        }

        const comptherIndex = benefits.findIndex(b => b.benefitCode === 'compther');
        if (comptherIndex === -1) {
            benefits.push({
                benefitCode: 'compther',
                optionCode: 'compther_no'
            })
        }
    }

    // Beneficios
    if(!data.selectedBenefitsIds['provdnet'] && data.selectedBenefits['geogrcov'] == 'wwltd') {
        benefits.push({
            benefitCode: 'provdnet',
            optionCode: '0'
        });
    } 
    
    if (data.selectedBenefits['geogrcov'] == 'wwltd') {
        benefits = benefits.map(benefit => {
            if (benefit.benefitCode === "provdnet") {
                return { ...benefit, optionCode: "0" };
            }
            return benefit;
        })
    }

    let deductibleUsa = 'dedusa_na'

    if (data.selectedBenefitsIds['geogrcov'] == 'wwide') {
        if (data.selectedBenefits["dedusa"] != 'dedusa_na') {
            deductibleUsa = data.selectedBenefits["dedusa"]
        }
    }

    if (data.organId) {
        benefits.push({
            benefitCode: 'orgtrans',
            optionCode: data.organId
        })
    }

    // Riders

    // No se envia este rider porque no se selecciono el check
    if (!data.step14Confirmation) {
        allowedRider = allowedRider.filter(benefit => benefit !== 'healthch')
    }

    // No se envia rider de maternidad porque el genero del owner es masculino y tambien el dependiente o no se selecciono el check
    if (!data?.outpationBenefitsmaternidad || !isFemale(data)) {
        allowedRider = allowedRider.filter(benefit => benefit !== 'matrnity')
    }

    let riders = Object.keys(data.selectedBenefitsIds)
        .filter((benefitName) => allowedRider.includes(benefitName.toLowerCase()))
        .map((benefitName) => ({
            benefitCode: benefitName.toLowerCase(),
            optionCode: data.selectedBenefitsIds[benefitName],
        }))

    return {
        initialCoverageDate: data.coverage,
        apQuoteId: apQuoteId?.toString(),
        language,
        paymentFrequency: data.timely,
        maxCoverage: data.selectedBenefits["maxcovpipoly"] ? data.selectedBenefits["maxcovpipoly"] : 'na',
        deductibleNonUsa: data.selectedBenefits["dednonusa"] ? data.selectedBenefits["dednonusa"] : 'na',
        deductibleUsa,
        coinsurance: data.selectedBenefits["coinsurance"],
        coinOop: data.selectedBenefits["coinsurance"] != 'coinsurance_no' ? data.selectedBenefits["maxcoinoop"] : 'maxcoinoop_no',
        beneficiaries: [
            {
                firstName: data.name,
                lastName: data.surname,
                email: data.email,
                dateOfBirth: data.birthday,
                gender: data.gender === "1" ? "male" : "female",
                countryOfResidenceIsoNum: data.country,
                beneficiaryType: "owner",
            },
            ...data.dependants.map((dependant) => {
                if (data.addDependant) {
                    return {
                        firstName: dependant.name,
                        lastName: dependant.surname,
                        email: dependant.email || null,
                        dateOfBirth: dependant.birthday,
                        gender: dependant.gender === "1" ? "male" : "female",
                        countryOfResidenceIsoNum: dependant.country,
                        beneficiaryType: dependant.componentId == '15' ? 'spouse' : 'dependent',
                    }
                }
                return null;
            }).filter(Boolean),
        ],
        benefits,
        riders,
        contextData: data
    };
};